import { useEffect, useState } from 'react';
import { ButtonField } from '@wk/components-react16';
import { API_URL } from '../../config/constants';
import HttpService from '../../config/http.service';
import { Toast } from '../../services';
import AddProject from './model/AddProject';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, store } from '../../store';
import DeleteConfirm from '../../components/DeleteConfirm';
import { Privilege } from '../../config/constants/privilege';
import { hideLoading, setAuthProject, showLoading } from '../../store/authReducer';

const ProjectTab = ({ data }: any) => {
    const dispatch = useDispatch();
    const { authUser, authProject } = useSelector((state: RootState) => state.auth);
    const [projectList, setProjectList] = useState([] as any);
    const [isLoad, setIsLoad] = useState(true);
    const [selectedItem, setSelectedItem] = useState({} as any);
    const [isOpenAddEdit, setIsOpenAddEdit] = useState(false);
    const [isOpenDeleteConfirm, setIsOpenDeleteConfirm] = useState(false);
    const [isEditPrivilege, setIsEditPrivilege] = useState(false);
    const [isDeletePrivilege, setIsDeletePrivilege] = useState(false);

    const addEdit = (item: any) => {
        setSelectedItem(item);
        setIsOpenAddEdit(true);
    }

    const getProjects = () => {
        dispatch(showLoading());
        HttpService.getRequest(API_URL.GET_PROJECT).then(
        (res: any) => {
            dispatch(hideLoading());
            setProjectList(res ? res : []);
        },
        (err: any) => {
            dispatch(hideLoading());
            Toast(err.message, "error");
        },
        )
    }

    const handleDelete = (item: any) => {
        setIsOpenDeleteConfirm(true);
        setSelectedItem(item);
    }

    const deleteItem = () => {
        if (authProject && authProject.id === selectedItem.id) {
            Toast("The Project you are currently using, can not be deleted. Please Exit or change the project selection and then try.", "error");
            return;
        }
        HttpService.deleteRequest(`${API_URL.DELETE_PROJECT}/${selectedItem.id}`).then(
            (res: any) => {
                Toast("Project deleted successfully.", "success");
                setIsLoad(true);
                setIsOpenDeleteConfirm(false);
                if (authProject && authProject.id === selectedItem.id) {
                    store.dispatch(setAuthProject({}));
                }
                setSelectedItem({});
            },
            (err: any) => {
                setIsOpenDeleteConfirm(false);
                setSelectedItem({});
                Toast(err.message, "error");
            }
        )
    }

    useEffect(() => {
        if (isLoad) {
            getProjects();
            setIsLoad(false);
        }
    }, [isLoad]);

    useEffect(() => {
        if (authUser && authUser.privileges) {
            setIsEditPrivilege(authUser.privileges.includes(Privilege[Privilege.EDIT_PROJECT_CONFIGURATION]));
            setIsDeletePrivilege(authUser.privileges.includes(Privilege[Privilege.DELETE_PROJECT_CONFIGURATION]));
        } else {
            setIsEditPrivilege(false);
            setIsDeletePrivilege(false);
        }
    }, [authUser]);

    return (
        <div className="p-20 wk-card-container mb-0 rounded-3 box-shadow">
            {isEditPrivilege && (
                <div className="wk-row">
                    <div className="wk-col-12 text-right">
                        <ButtonField size={'small'} mode={'ghost'}>
                            <button type="button" className="mr-5" onClick={() => addEdit({})}>
                                Add Project
                            </button>
                        </ButtonField>
                    </div>
                </div>
            )}
            <div className="wk-row mt-10">
                <div className="wk-col-12">
                    <table className="wk-table wk-table-bordered wk-table-small">
                        <thead>
                            <tr>
                                <th>Project Name</th>
                                <th>Code</th>
                                {(isEditPrivilege || isDeletePrivilege) && (<th style={{ width: '80px' }}>Actions</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {projectList.length > 0 ? projectList.map((item: any, index: number) => (
                                <tr key={index}>
                                    <td>{item.name}</td>
                                    <td>{item.code}</td>
                                    {(isEditPrivilege || isDeletePrivilege) && (
                                        <td>
                                            {isEditPrivilege && <span className="wk-icon-pencil mr-10 cursor" title="Edit"
                                                onClick={() => addEdit(item)}></span>}
                                            {isDeletePrivilege && <span className="wk-icon-trash cursor" title="Delete" onClick={() => handleDelete(item)}></span>}
                                        </td>
                                    )}
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan={(isEditPrivilege || isDeletePrivilege) ? 3 : 2} className="text-center" style={{ height: '7rem' }}>
                                        No record found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            {isOpenAddEdit && <AddProject data={{ isOpenAddEdit, setIsOpenAddEdit, selectedItem, setIsLoad}} />}
            {isOpenDeleteConfirm && <DeleteConfirm data={{ isOpenDeleteConfirm, setIsOpenDeleteConfirm, deleteItem, message: `Are you sure you want to delete?` }} />}
        </div>
    );
};

export default ProjectTab;